module.exports = __webpack_public_path__ + "img/2.6c69b9ac.png";